/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../../EmployeeScreens/EMPHolidays/EMPHoliday.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight, MdSearch } from "react-icons/md";
import { Modal } from "react-bootstrap";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import NewEmployeesModal from "../../../Components/Modals/NewEmployeesModal";
import { Apiurl, GetToken } from "../../../Utils/utils";
import axios from "axios";
import Loader from "../../../Components/loader/loader";
import moment from "moment";

const EMPHolidays = () => {
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [holidayData, setHolidayData] = useState([]);
  const [searchType, setSearchType] = useState("HolidayName");

  const loginToken = GetToken();

  const GetAllHolidays = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${loginToken}`,
      },
      url: `${Apiurl()}/Holiday/GetAllHoliday`,
    };

    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setHolidayData(data);
        setLeaveRequestDuplicate(data);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    GetAllHolidays();
  }, []);

  const handleDataSearch = (e) => {
    const searchData = e?.target?.value?.toLowerCase();

    if (searchData) {
      const filterData = leaveRequestDuplicate.filter((item) => {
        if (searchType === "HolidayName") {
          return item?.HolidayName?.toLowerCase()?.includes(searchData);
        }

        if (searchType === "Date") {
          return moment(item?.FromDate)
            .format("DD MMM YYYY")
            .toLowerCase()
            .includes(searchData);
        }

        return false;
      });

      setHolidayData(filterData);
    } else {
      setHolidayData(leaveRequestDuplicate);
    }
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }

    setShowSidebar(true);
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}

      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "EMP-Holiday-main-container-of-all-employees-page"
              : "EMP-Holiday-main-container-of-all-employees-page-new"
          }
        >
          <div className="vdjhbhf">
            <div className="EMp-Holiday-inner-container-of-all-employees-page">
              <div className="holiday-page-topbar">
                <div className="holiday-page-title-wrap">
                  <p className="holiday-page-title">Holiday</p>
                </div>

                <div className="holiday-page-breadcrumb">
                  <BiHomeAlt className="holiday-breadcrumb-home" />
                  <MdKeyboardArrowRight className="holiday-breadcrumb-arrow" />
                  <p className="holiday-breadcrumb-text">Holiday</p>
                  <MdKeyboardArrowRight className="holiday-breadcrumb-arrow" />
                  <p className="holiday-breadcrumb-text">All Holidays</p>
                </div>
              </div>
            </div>

            <div className="EMP-body-part-outer-container">
              <div
                className="EMP-inner-body-container-of-employee-table row-12"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 15px",
                  backgroundColor: "white",
                  borderRadius: "10px 10px 0 0",
                }}
              >
                <div
                  className="first-side-in-body-header col-6"
                  style={{ display: "flex", alignItems: "center", gap: "16px" }}
                >
                  <div className="EMP-employee-text-in-body">
                    <h2
                      style={{
                        margin: 0,
                        fontSize: "17px",
                        fontWeight: 600,
                        color: "#5b626b",
                      }}
                    >
                      Holidays
                    </h2>
                  </div>

                  <div
                    className="EMP-input-for-search-in-employee-body"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <select
                      className="EMP-search-dropdown"
                      value={searchType}
                      onChange={(e) => setSearchType(e.target.value)}
                      style={{
                        height: "38px",
                        padding: "0 10px",
                        border: "1px solid #ccc",
                        borderRight: "none",
                        borderRadius: "4px 0 0 4px",
                        fontSize: "13px",
                        color: "#555",
                        backgroundColor: "#f9f9f9",
                        outline: "none",
                        cursor: "pointer",
                      }}
                    >
                      <option value="HolidayName">Holiday Name</option>
                      <option value="Date">Date</option>
                    </select>

                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <MdSearch
                        style={{
                          position: "absolute",
                          left: "8px",
                          fontSize: "17px",
                          color: "#aaa",
                          pointerEvents: "none",
                          zIndex: 1,
                        }}
                      />

                      <input
                        type="text"
                        placeholder={`Search by ${
                          searchType === "HolidayName" ? "holiday name" : "date"
                        }`}
                        onChange={handleDataSearch}
                        style={{
                          height: "38px",
                          paddingLeft: "30px",
                          paddingRight: "12px",
                          border: "1px solid #ccc",
                          borderRadius: "0 4px 4px 0",
                          fontSize: "13px",
                          color: "#555",
                          outline: "none",
                          minWidth: "200px",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="main-class-for-table-in-empholiday">
                <table className="table-of-employee-empholiday">
                  <thead className="thead-of-emp-table-empholiday">
                    <tr className="row">
                      <th className="col-2">Sr. No.</th>
                      <th className="col-4">Holiday Name</th>
                      <th className="col-4">Date</th>
                      <th className="col-2">Day</th>
                    </tr>
                  </thead>

                  <tbody className="tbody-ofemp-table-empholiday">
                    {holidayData?.length ? (
                      <>
                        {holidayData
                          ?.sort(
                            (a, b) =>
                              new Date(a.FromDate).getTime() -
                              new Date(b.FromDate).getTime()
                          )
                          .map((item, index) => {
                            const Date = moment(item?.FromDate).format(
                              "DD MMM YYYY"
                            );

                            return (
                              <tr className="row" key={index}>
                                <td className="col-2">{index + 1}</td>
                                <td className="col-4">{item?.HolidayName}</td>
                                <td className="col-4">{Date}</td>
                                <td className="col-2">{item?.Days}</td>
                              </tr>
                            );
                          })}
                      </>
                    ) : (
                      <tr className="no-record-found-tr-dashboard">
                        <td colSpan="10">No record found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-in-employee-table"
      >
        <NewEmployeesModal className="modal-main-inner-container" />
      </Modal>
    </>
  );
};

export default EMPHolidays;